/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React from 'react'
import { useServiceContext } from '../../../../root'
import { RcmTableDataWrapper } from '../../../rcm-table/RcmTableDataWrapper'
import { RecentDocsTable } from './RecentDocsTable'
import useDocumentsListService from '../../../../hooks/useDocumentsListService'

export const RecentDocsSection: React.FC = () => {
  const {
    service: {
      filter: { translate }
    }
  } = useServiceContext()
  const { loadRecent } = useDocumentsListService()

  const loadDataRecentDocs = () => {
    const defaultFilter = {
      pageSize: 5,
      pageStart: 0
    }
    return loadRecent(defaultFilter)
  }

  return (
    <>
      <h2 className="recent-docs">{translate('RECENT_DOCUMENTS')}</h2>
      <RcmTableDataWrapper persistenceKey={'dashboardRecentFiles'} loadData={loadDataRecentDocs}>
        <RecentDocsTable />
      </RcmTableDataWrapper>
    </>
  )
}
